/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamFragmentDoc, TeamPreviewFragmentDoc } from "./fragment.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type TeamsQueryVariables = Exact<{ [key: string]: never }>

export type TeamsQuery = {
  __typename: "Query"
  teams?: Array<{
    __typename: "Team"
    id: string
    name: string
    description?: string | null
  }> | null
}

export type TeamQueryVariables = Exact<{
  id: string
}>

export type TeamQuery = {
  __typename: "Query"
  team: {
    __typename: "Team"
    createdAt: string
    updatedAt: string
    id: string
    name: string
    description?: string | null
    memberships: Array<{
      __typename: "TeamMember"
      id: string
      role: string
      invitedAt?: string | null
      invitationAcceptedAt?: string | null
      invitationAccepted: boolean
      createdAt: string
      updatedAt: string
      user?: {
        __typename: "User"
        id: string
        name?: string | null
        email: string
        createdAt: string
        updatedAt: string
      } | null
    }>
    projects?: Array<{
      __typename: "Project"
      id: string
      title: string
      phase?: {
        __typename: "ProjectPhase"
        id: string
        value: string
        label: string
      } | null
    }> | null
  }
}

export const TeamsDocument = gql`
  query Teams {
    teams @rest(type: "Team", path: "/project-list/teams") {
      ...TeamPreview
    }
  }
  ${TeamPreviewFragmentDoc}
`

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(
    TeamsDocument,
    options
  )
}
export function useTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(
    TeamsDocument,
    options
  )
}
// @ts-ignore
export function useTeamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsQuery, TeamsQueryVariables>
export function useTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamsQuery | undefined, TeamsQueryVariables>
export function useTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(
    TeamsDocument,
    options
  )
}
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>
export type TeamsSuspenseQueryHookResult = ReturnType<
  typeof useTeamsSuspenseQuery
>
export type TeamsQueryResult = Apollo.QueryResult<
  TeamsQuery,
  TeamsQueryVariables
>
export const TeamDocument = gql`
  query Team($id: ID!) {
    team(id: $id)
      @rest(
        type: "Team"
        path: "/project-list/teams/{args.id}?include=projects,members"
      ) {
      ...Team
    }
  }
  ${TeamFragmentDoc}
`

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(
  baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables> &
    ({ variables: TeamQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options)
}
export function useTeamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(
    TeamDocument,
    options
  )
}
// @ts-ignore
export function useTeamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamQuery, TeamQueryVariables>
export function useTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>
): Apollo.UseSuspenseQueryResult<TeamQuery | undefined, TeamQueryVariables>
export function useTeamSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TeamQuery, TeamQueryVariables>(
    TeamDocument,
    options
  )
}
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>
export type TeamSuspenseQueryHookResult = ReturnType<
  typeof useTeamSuspenseQuery
>
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>
